module.exports = __webpack_public_path__ + "static/media/disabledHorizontalAllIcon.47f9d6ff.svg";